import React, { ReactNode } from 'react';

import HappyFaceSvg from 'App/assets/img/happy-face.svg?url';

import { ModalContainer } from '@welbe/web-design-system';

import { Container, Content, Title } from './ModalCandidateCsv.styles';

type ModalCandidateCsvProps = {
	onClose: () => void;
	imageUrl?: string;
	message?: string;
	children?: ReactNode;
	height?: string;
	width?: string;
	visible?: boolean;
	hasCloseButton?: boolean;
};

export const ModalCandidateCsv = ({
	onClose,
	imageUrl,
	message,
	children,
	height = '15vh',
	width,
	visible,
	hasCloseButton = true,
}: ModalCandidateCsvProps): JSX.Element => {
	return (
		<ModalContainer
			visible={visible}
			height={height}
			zIndex={1400}
			closeOnlyOnTheButton
			hasCloseButton={hasCloseButton}
			onClose={onClose}
			width={width}
		>
			<Container>
				<Content>
					<img src={imageUrl || HappyFaceSvg} alt="Modal Confirm" />
					<Title centralize>{message || '¡Sucesso!'}</Title>
					{children}
				</Content>
			</Container>
		</ModalContainer>
	);
};
